export const OPEN_JOIN_CLUB_QUESTION = 1;// 加入俱乐部问题弹窗
export const OPEN_JOIN_CLUB_APPLY = 2;// 加入俱乐部审核中弹窗
export const OPEN_JOIN_CLUB_SUCCESS = 3;// 已加入俱乐部弹窗
export const OPEN_GO_UNION_SQUARE = 4;// 去群聊弹窗（未加入俱乐部，跳转俱乐部广场）
export const OPEN_JOIN_CHAT = 5;// 去群聊弹窗（已加入俱乐部，跳转群聊）
export const OPEN_SELECT_CLUB = 6;// 选择俱乐部
